import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ kicker, title, subtitle, dark = false, testId }) => (
  <div className="mb-12 md:mb-16" data-testid={testId}>
    {kicker && (
      <Reveal>
        <span className="inline-flex items-center gap-2 font-technical uppercase tracking-[0.3em] text-sm text-fw-gold">
          <span className="h-px w-8 bg-fw-gold" />
          {kicker}
        </span>
      </Reveal>
    )}
    <Reveal delay={0.05}>
      <h2
        className={`mt-4 font-technical uppercase font-bold tracking-tight text-4xl md:text-6xl leading-[0.95] ${
          dark ? "text-white" : "text-fw-navy"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.1}>
        <p
          className={`mt-3 font-heritage italic text-xl md:text-2xl ${
            dark ? "text-fw-gold" : "text-fw-red"
          }`}
        >
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);
